import React, { HTMLProps, MouseEvent, useRef } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { Row, RowData, Table } from "@tanstack/react-table";
import { setLastSelectedRowID } from "src/redux";

export function IndeterminateCheckbox<TData extends RowData>({
  row,
  table,
  indeterminate,
  className = "",
  ...rest
}: {
  row?: Row<TData>;
  table: Table<TData>;
  indeterminate?: boolean;
} & Omit<HTMLProps<HTMLInputElement>, "ref">) {
  const ref = useRef<HTMLInputElement>(null!);

  const lastSelectedRowID = useSelector(
    (state: RootStateOrAny) => state.taskReducer.lastSelectedRowID,
  );

  const dispatch = useDispatch();

  const handleCheckboxClick = (e: MouseEvent<HTMLLabelElement>) => {
    if (!row) return;

    const isSelected = row.getIsSelected();

    if (e.shiftKey && lastSelectedRowID) {
      const { rows } = table.getRowModel();

      const currentIndex = rows.findIndex((r) => r.id === row.id);
      const lastIndex = rows.findIndex((r) => r.id === lastSelectedRowID);

      if (currentIndex === -1 || lastIndex === -1) return;

      const [start, end] = [currentIndex, lastIndex].sort((a, b) => a - b);

      const rowsToToggle = rows.slice(start, end + 1);

      rowsToToggle.forEach((r) => r.toggleSelected(!isSelected));
    } else {
      row.toggleSelected(!isSelected);
    }

    dispatch(setLastSelectedRowID(row.id));
  };

  return (
    <label
      className="indeterminate-checkbox-label"
      onMouseDown={handleCheckboxClick}
    >
      <input
        type="checkbox"
        ref={ref}
        className={`${className} cursor-pointer`}
        {...rest}
      />
    </label>
  );
}
